export function selectModel() {
    $('.models-section .model-select').on('change', function (e) {
        let valueSelected = this.value;
        if (valueSelected !== 'undefined' && valueSelected !== "") {
            $('.models-section .model-select').each(function(){
                if(this.value != valueSelected){
                    $(this).val(valueSelected).change();;
                }
            })
            $('.models-section .reusable-comp').hide();
            $('.models-section #reusable-comp-'+valueSelected).show();
        }
    });
}